import axios from "axios";
import React, { createContext, useState, useEffect } from "react";

export const DataContext = createContext();

function DataProvider({ children }) {

  const [images, setImages] = useState([]);
  const [cardStyles, setCardStyles] = useState([]);
  const [error, setError] = useState("");
    
  const fetchImages = async () => {
    try {
      const response = await axios.get("/images/gallery");
      setImages(response.data.images);
      setCardStyles(response.data.cardStyles);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    }
  };


  const props = {
    images,
    error,
    cardStyles,
    fetchImages
  };

  return (
    <DataContext.Provider value={{ ...props }}>
      {children}
    </DataContext.Provider>
  );
}

export default DataProvider;

